import { giveawayStepTransitions, goodieGiveawayStepTransitions } from 'swag-common/business-logic/giveaway/steps/giveaway-step-transitions';
import { GiveawayTypes } from 'swag-common/interfaces';
export const getGiveawayPreviousStep = (activeStep, data, type = GiveawayTypes.swag) => {
  const steps = type === GiveawayTypes.swag ? giveawayStepTransitions : goodieGiveawayStepTransitions;
  const state = steps.find(state => state.key === activeStep) || steps[0];
  if (!state || !state.previousState) {
    return activeStep;
  }
  return state.previousState(data);
};